import { IFileType } from "@zappar/zw-api-client";
import { ZapworksAsset } from "./base";
import { MediaType } from "../../../types";

export class VideoAsset extends ZapworksAsset<IFileType.StreamingVideo> {
  getMediaType() {
    return MediaType.Video;
  }

  async getImageUrlForCard(size?: { width: number; height?: number }, useCache = true) {
    const baseUrl = await this.getFileUrl(useCache);
    let path = 'frame0.png';
    // if (size) { // TODO: Uncomment when Zapworks supports resized thumbnails for Videos
    //   path = `frame0.png.r.w${size.width}${size.height ? `.h${size.height}` : ''}.png`;
    // }
    return this.addPathToFileUrl(new URL(baseUrl), path).toString();
  }

  async getPreviewUrl(size?: { width: number; height?: number }, useCache = true) {
    const baseUrl = await this.getFileUrl(useCache);
    return this.addPathToFileUrl(new URL(baseUrl), 'video.mp4').toString();
  }

  async getDownloadUrl() {
    return this.getImageUrlForCard()  // TODO: Replace with URL to original file if available
  }
}
